export default "__VITE_ASSET__BDX52DIU__"